/**
 * Tiêu đề khối trên Bảng điều khiển — cùng format với "Công việc cần xử lý".
 */
import { Box, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

type Props = {
  title: string
  subtitle?: string
  /** Gộp thêm / ghi đè (vd. `{ mb: 1 }` khi khối dưới đã có thanh công cụ margin). */
  sx?: SxProps<Theme>
}

export default function WorkspaceSectionHeading({ title, subtitle, sx }: Props) {
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Typography variant="h4" sx={{ fontSize: 24, fontWeight: 600, color: 'primary.main' }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  )
}
